import React from 'react'
import { AnimatePresence, motion } from 'framer-motion'
import { UploadIcon } from '@/atoms/Icons/UploadIcon'
import { IconColor } from '@/atoms/utils/IconTypes'

interface ShareButtonProps {
  isHeroInView: boolean
  setIsShareModalOpen: (value?: boolean) => void
  classes?: string
}

export const ShareButton: React.FC<ShareButtonProps> = ({ isHeroInView, setIsShareModalOpen, classes }) => {
  return (
    <AnimatePresence>
      <motion.button
        initial={{ y: 100, opacity: 0 }}
        animate={{ y: 0, opacity: 1 }}
        onClick={() => setIsShareModalOpen(true)}
        className={`${classes} fixed  right-6 z-50 rounded-full bg-[#F9DA8F] p-[14px] drop-shadow-md md:bottom-6 ${
          isHeroInView ? 'hidden md:block' : 'block'
        }`}
      >
        <UploadIcon size={28} color={'#2C2C33' as IconColor} />
      </motion.button>
    </AnimatePresence>
  )
}
